














































































































































































































































import { Component, Ref, Vue, Watch } from "vue-property-decorator";
import { DataOptions, DataTableHeader } from "vuetify";
import {
  ControllersApi,
  GetControllerResponse,
  GetLocationResponse,
  LocationModel,
  LocationsApi,
  VariableModel,
  VariablesApi,
  PostVariableRequest,
  VariablesApiCheckImportVariablesRequest,
  VariablesApiImportVariablesRequest,
} from "../../../apis";
import { IAction } from "../common/CommonTypes";
import MoreVertBtn from "../common/MoreVertBtn.vue";
import { ACTION } from "./";
import VariableDialog from "./VariableDialog.vue";
import { VueExcelEco2 } from "../common/VueExcelEco2";
import { utils, writeFile, read } from "xlsx-with-styles";
import { isEmpty, toNumber, forEach } from "lodash";

@Component({
  components: { MoreVertBtn, VariableDialog },
})
export default class Variable extends Vue {
  showVariableDetailDialog = false;
  showDeleteVariableDialog = false;
  showConfirmImportVariableDialog = false;
  showRecommendedAction = false;
  importVariablesRequest: VariablesApiCheckImportVariablesRequest = null;

  searchForm = {
    keyword: "",
    type: "",
  };
  importVariableData;

  columnsExport = [
    {
      label: this.$t("text.variableName"),
      field: "variableName",
    },
    {
      label: this.$t("text.Color"),
      field: "color",
    },
    {
      label: this.$t("text.controllerVariableMemory"),
      field: "memory",
    },
    {
      label: this.$t("text.type"),
      field: "type",
    },
    {
      label: this.$t("text.unit"),
      field: "unit",
    },
    {
      label: this.$t("text.icon"),
      field: "icon",
    },
    {
      label: this.$t("text.recommendedActions"),
      field: "recommendedAction",
    },
    {
      label: this.$t("text.alarm"),
      field: "alarm",
    },
    {
      label: this.$t("text.startStop"),
      field: "startStop",
    },
    {
      label: this.$t("text.o2Up"),
      field: "o2Up",
    },
    {
      label: this.$t("text.remainingO2DownTime"),
      field: "remainingO2DownTime",
    },
    {
      label: this.$t("text.greenButton"),
      field: "greenButton",
    },
    {
      label: this.$t("text.home"),
      field: "home",
    },
    {
      label: this.$t("text.status"),
      field: "status",
    },
    {
      label: this.$t("text.parameter"),
      field: "parameter",
    },
    {
      label: this.$t("text.calibrationParameter"),
      field: "calibrationParameter",
    },
    {
      label: this.$t("text.readonly"),
      field: "readOnly",
    },
    {
      label: this.$t("text.operationTime"),
      field: "operationTime",
    },
    {
      label: this.$t("text.inProgress"),
      field: "inProgress",
    },
    {
      label: this.$t("text.recordData"),
      field: "recordData",
    },
    {
      label: this.$t("text.graph"),
      field: "graph",
    },
  ];

  dataExport = [];

  mode: ACTION = null;
  locationDetailResponse: LocationModel = null;
  variables: VariableModel[] = [];
  variablesExport: VariableModel[] = [];
  selectedVariable: VariableModel = null;
  selectedVariables: VariableModel[] = [];
  pagingOption: DataOptions | null = null;
  totalItems = 0;
  getLocationResponse: GetLocationResponse = null;
  getControllerResponse: GetControllerResponse = null;

  @Ref("variableExportRef") readonly variableExportRef!: any;

  get ACTIONS(): Array<IAction> {
    return [
      {
        titleName: this.$t("text.edit"),
        action: ACTION.EDIT_VARIABLE,
        permission: { context: "VARIABLES_MANAGEMENT", action: "update" },
      },
      {
        titleName: this.$t("text.delete"),
        action: ACTION.DELETE_VARIABLE,
        titleStyle: "color: red",
        permission: { context: "VARIABLES_MANAGEMENT", action: "delete" },
      },
    ];
  }

  get TYPES() {
    return [
      { text: "Bool", value: "BOOL" },
      { text: "Byte", value: "BYTE" },
      { text: "UByte", value: "UBYTE" },
      { text: "Word", value: "WORD" },
      { text: "Floating", value: "FLOATING" },
      { text: "Time", value: "TIME" },
    ];
  }

  get CHECKBOXES() {
    return [
      {
        text: this.$t("text.alarm"),
        value: "alarm",
        class: ["tw-whitespace-no-wrap"],
        cellClass: ["tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.startStop"),
        value: "startStop",
        class: ["tw-whitespace-no-wrap"],
        cellClass: ["tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.o2Up"),
        value: "o2Up",
        class: ["tw-whitespace-no-wrap"],
        cellClass: ["tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.remainingO2DownTime"),
        value: "remainingO2DownTime",
        class: ["tw-whitespace-no-wrap"],
        cellClass: ["tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.greenButton"),
        value: "greenButton",
        class: ["tw-whitespace-no-wrap"],
        cellClass: ["tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.home"),
        value: "home",
        class: ["tw-whitespace-no-wrap"],
        cellClass: ["tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.status"),
        value: "status",
        class: ["tw-whitespace-no-wrap"],
        cellClass: ["tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.parameter"),
        value: "parameter",
        class: ["tw-whitespace-no-wrap"],
        cellClass: ["tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.calibrationParameter"),
        value: "calibrationParameter",
        class: ["tw-whitespace-no-wrap"],
        cellClass: ["tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.readonly"),
        value: "readOnly",
        class: ["tw-whitespace-no-wrap"],
        cellClass: ["tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.operationTime"),
        value: "operationTime",
        class: ["tw-whitespace-no-wrap"],
        cellClass: ["tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.inProgress"),
        value: "inProgress",
        class: ["tw-whitespace-no-wrap"],
        cellClass: ["tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.recordData"),
        value: "recordData",
        class: ["tw-whitespace-no-wrap"],
        cellClass: ["tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.graph"),
        value: "graph",
        class: ["tw-whitespace-no-wrap"],
        cellClass: ["tw-whitespace-no-wrap"],
      },
    ] as DataTableHeader[];
  }

  get HEADERS() {
    const headers_ = [
      {
        text: this.$t("text.variableName"),
        value: "variableName",
        class: ["column-sticky", "tw-whitespace-no-wrap"],
        cellClass: ["column-sticky", "tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.controllerVariableMemory"),
        value: "memory",
        class: ["column-sticky", "tw-whitespace-no-wrap"],
        cellClass: ["column-sticky", "tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.type"),
        value: "type",
        class: ["column-sticky", "tw-whitespace-no-wrap"],
        cellClass: ["column-sticky", "tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.unit"),
        value: "unit",
        class: ["column-sticky", "tw-whitespace-no-wrap"],
        cellClass: ["column-sticky", "tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.icon"),
        value: "icon",
        class: ["column-sticky", "tw-whitespace-no-wrap"],
        cellClass: ["column-sticky", "tw-whitespace-no-wrap"],
      },
      {
        text: this.$t("text.recommendedActions"),
        value: "recommendedAction",
        class: ["tw-whitespace-no-wrap"],
        cellClass: ["tw-whitespace-no-wrap"],
      },
      ...this.CHECKBOXES,
      {
        text: this.$t("text.action"),
        value: "action",
        align: "start",
        class: ["tw-whitespace-no-wrap"],
        cellClass: ["tw-whitespace-no-wrap"],
      },
    ] as DataTableHeader[];
    if (this.$store.getters.user.organization === "CLIENT") {
      this.lodash.remove(headers_, (val) => val.value === "action");
    } else {
      if ((this as any).$hasPermission({
        context: 'VARIABLES_MANAGEMENT',
        action: 'delete',
      })) {
        headers_.push({ text: '', value: 'data-table-select' });
      }
    }
    return headers_;
  }

  fileNameExport =
    "[Customer name]_[Location name]_[Controller name]_Variables";

  async created() {
    const { id, plcId } = this.$route.params;
    const rs = await Promise.all([
      new LocationsApi().getLocationById({ id }),
      new ControllersApi().getController({ id: plcId }),
    ]);
    if (rs && rs.length > 0) {
      this.getLocationResponse = rs[0].data;
      this.getControllerResponse = rs[1].data;
      let _title =
        this.getControllerResponse.data.name +
        "'s " +
        this.$t(`text.variables`);
      if (this.$store.getters.locale === "vi") {
        _title =
          this.$t(`text.parameterOfController`) +
          " " +
          this.getControllerResponse.data.name;
      }
      this.$store.commit("SET_BREADCUMB", {
        title: _title,
      });
      //update fileNameExport
      this.fileNameExport = `${this.getLocationResponse.data.customerName}_${this.getLocationResponse.data.locationName}_${this.getControllerResponse.data.name}_Variables`;
    }
  }

  mounted() {
    const btn = document.querySelector(
      ".button-add-variable"
    ) as HTMLButtonElement;
    if (btn) {
      btn.onclick = () => {
        this.showVariableDetailDialog = true;
        this.mode = ACTION.NEW_VARIABLE;
      };
    }
  }

  updated() {
    this.$nextTick(() => {
      const variable_container = document.querySelector(".variable-container");
      const search_form = document.querySelector(".search-form");
      // const css_variable_container = window.getComputedStyle(variable_container);
      // const css_search_form = window.getComputedStyle(search_form);
      const table_wrapper = document.querySelector(
        ".variable-table div.v-data-table__wrapper"
      ) as HTMLDivElement;
      table_wrapper.style.maxHeight = `${
        variable_container.clientHeight - search_form.clientHeight - 64 - 60 - 5
      }px`;
    });

    const tableThs: any = document.querySelectorAll(
      ".variable-table table thead tr th"
    );
    this.$nextTick(() => {
      const leftPxArr = [];
      for (let idx = 0; idx <= 6; idx++) {
        const headTh: any = document.querySelector(
          `table > thead > tr > th:nth-child(${idx + 2})`
        );
        const bodyTds: any = (numb) =>
          document.querySelectorAll(
            `table > tbody > tr > td:nth-child(${numb})`
          );
        leftPxArr.push(tableThs[idx].getBoundingClientRect().width);
        const leftPx = leftPxArr.reduce(
          (previousValue, currentValue) => previousValue + currentValue,
          0
        );
        if (headTh) {
          headTh.style.left = leftPx + "px";
          // headTh.style.backgroundColor = `rgb(254 254 254)`;
        }
        const bodyTs2 = bodyTds(idx + 2);
        if (bodyTs2) {
          bodyTs2.forEach((td) => {
            td.style.left = leftPx + "px";
          });
        }
      }
    });
  }

  get ROW_PER_PAGES() {
    return this.$util.getConfig().settings.rowPerPage;
  }

  get addEmailClick() {
    return this.$store.getters.addEmailClick;
  }

  onSearch() {
    this.doSearch();
  }

  //   async onSelectedAction(item, action) {
  //     this.selectedVariable = { ...item };
  //     switch (action) {
  //       case ACTION.EDIT_VARIABLE: {
  //         this.mode = ACTION.EDIT_VARIABLE;
  //         this.showVariableDetailDialog = true;
  //         break;
  //       }
  //       case ACTION.DELETE_VARIABLE: {
  //         this.showDeleteVariableDialog = true;
  //         break;
  //       }
  //       default: {
  //         break;
  //       }
  //     }
  //   }

  async onOkConfirmDeleteVariableDialog() {
    this.$util.showLoading();
    try {
      if (this.selectedVariables.length > 1){
        await new VariablesApi().deleteVariables({ variables: this.selectedVariables.map(v=> v.id) });
      } else {
        await new VariablesApi().deleteVariable({ id: this.selectedVariable.id });
      }

    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
    this.doSearch();
    this.showDeleteVariableDialog = false;
  }

  onPagingOption() {
    this.doSearch();
  }

  onEdit(item: VariableModel) {
    this.selectedVariable = item;
    this.mode = ACTION.EDIT_VARIABLE;
    this.showVariableDetailDialog = true;
  }

  onRemove(item: VariableModel) {
    this.selectedVariable = item;
    this.showDeleteVariableDialog = true;
  }

  async doSearch() {
    this.$util.showLoading();
    const { plcId } = this.$route.params;
    this.selectedVariables= [];
    try {
      const rs = await new VariablesApi().getVariablesByTypeKeyword({
        orderBy:
          this.pagingOption.sortBy.length > 0
            ? this.pagingOption.sortBy[0]
            : "",
        orderDesc:
          this.pagingOption.sortDesc.length > 0
            ? "" + this.pagingOption.sortDesc[0]
            : "",
        page: this.pagingOption.page,
        limit: this.pagingOption.itemsPerPage,
        controllerId: plcId,
        type: this.searchForm.type || "",
        keyword: this.searchForm.keyword || "",
      });
      this.totalItems = rs.data.count;
      this.variables = rs.data.data;
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  onViewRecommendedAction(selectedVariable) {
    this.showRecommendedAction = true;
    this.selectedVariable = selectedVariable;
  }

  get exportClick() {
    return this.$store.getters.exportVariable;
  }

  @Watch("exportClick")
  onexportClick() {
    this.doExport();
  }

  get importClick() {
    return this.$store.getters.importVariable;
  }

  @Watch("importClick")
  onImportClick() {
    const ref = this.$refs.inputFileRef as any;
    ref.value = null;
    ref.click();
  }

  async doExport() {
    this.$util.showLoading();
    const { plcId } = this.$route.params;
    try {
      const rs = await new VariablesApi().exportVariables({
        orderBy:
          this.pagingOption.sortBy.length > 0
            ? this.pagingOption.sortBy[0]
            : "",
        orderDesc:
          this.pagingOption.sortDesc.length > 0
            ? "" + this.pagingOption.sortDesc[0]
            : "",
        controllerId: plcId,
        type: this.searchForm.type || "",
        keyword: this.searchForm.keyword || "",
      });
      this.dataExport = rs.data.data.map((variable) => {
        for (const key in variable) {
          if (typeof variable[key] === "boolean") {
            variable[key] = variable[key] === true ? "x" : "";
          }
          if (key === "icon") {
            variable["icon"] = this.getIconIdByCode(variable[key]);
          }
        }
        return variable;
      });
    } catch (error) {
      this.$util.showError(error);
    } finally {
      const data = this.lodash.reverse(this.dataExport);
      const exportExcel = new VueExcelEco2(
        this.fileNameExport,
        "xlsx",
        "Export Variables",
        data,
        this.columnsExport
      ).exportExcel();
      this.$util.hideLoading();
    }
  }

  async doImport() {
    this.importVariablesRequest = null;
    this.importVariableData[0].shift(); // remove header
    const [arrayVariableData] = this.importVariableData;
    this.$util.showLoading();
    try {
      const body = this.createBodyImportVariablesRequest(arrayVariableData);
      const res = await new VariablesApi().checkImportVariables(body);
      if (res.data.ok) {
        this.showConfirmImportVariableDialog = true;
        this.importVariablesRequest = body;
      }
      return;
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
    }
  }

  async onOkConfirmImportVariableDialog() {
    const body = this.importVariablesRequest;
    this.$util.showLoading();
    try {
      const res = await new VariablesApi().importVariables(body);
    } catch (error) {
      this.$util.showError(error);
    } finally {
      this.$util.hideLoading();
      this.showConfirmImportVariableDialog = false;
      this.doSearch();
    }
  }

  keysMap = [
    "variableName",
    "color",
    "memory",
    "type",
    "unit",
    "icon",
    "recommendedAction",
    "alarm",
    "startStop",
    "o2Up",
    "remainingO2DownTime",
    "greenButton",
    "home",
    "status",
    "parameter",
    "calibrationParameter",
    "readOnly",
    "operationTime",
    "inProgress",
    "recordData",
    "graph",
  ];

  keysBoolean = [
    "alarm",
    "startStop",
    "o2Up",
    "remainingO2DownTime",
    "greenButton",
    "home",
    "status",
    "parameter",
    "calibrationParameter",
    "readOnly",
    "operationTime",
    "inProgress",
    "recordData",
    "graph",
  ];

  get ICONS() {
    return [
      { id: 1, text: "O2 Down", value: "O2_DOWN" },
      { id: 2, text: "Flushing", value: "FLUSHING" },
      { id: 3, text: "Pulldown", value: "PULLDOWN" },
      { id: 4, text: "O2 Up", value: "O2_UP" },
      { id: 5, text: "Ventilator", value: "VENTILATOR" },
      { id: 6, text: "Heater", value: "HEATER" },
      { id: 7, text: "Humidifier", value: "HUMIDIFIER" },
      { id: 8, text: "Dehumidification", value: "DEHUMIDIFICATION" },
      { id: 9, text: "Overflow (give)", value: "OVERFLOW_GIVE" },
      { id: 10, text: "Overflow (receive)", value: "OVERFLOW_RECEIVE" },
      { id: 11, text: "Air compressor", value: "AIR_COMPRESSOR" },
      { id: 12, text: "N2 generator", value: "N2_GENERATOR" },
      { id: 13, text: "Green Light", value: "GREEN_LIGHT" },
      { id: 14, text: "Red Light", value: "RED_LIGHT" },
      { id: 15, text: "Tempt Up", value: "TEMPT_UP" },
      { id: 16, text: "Temp Down", value: "TEMP_DOWN" },
    ];
  }

  getIconCodeById(id: string): string {
    const iconFound = this.ICONS.find((icon) => icon.id === toNumber(id));
    return iconFound ? iconFound.value : "";
  }

  getIconIdByCode(code: string): string {
    const iconFound = this.ICONS.find((icon) => icon.value === code);
    return iconFound ? iconFound.id.toString() : "";
  }

  createBodyImportVariablesRequest(
    arrayVariableData: Array<Array<string>>
  ): VariablesApiCheckImportVariablesRequest {
    const csvData: PostVariableRequest[] = arrayVariableData.map(
      (variableValues) => {
        const initialVariableObject = {} as PostVariableRequest;
        return variableValues.reduce((variableObject, value, idx) => {
          const key = this.keysMap[idx];
          if (!this.isValidCell(key, value.toString())) {
            throw this.errorImportMsg;
          }
          return {
            ...variableObject,
            [key]: this.keysBoolean.includes(key)
              ? value === "x"
              : key === "icon"
              ? this.getIconCodeById(value)
              : value,
            controller: this.getControllerResponse.data.id,
          } as PostVariableRequest;
        }, initialVariableObject);
      }
    );
    return {
      postImportVariableRequest: {
        csvData,
      },
    };
  }

  errorImportMsg = null;
  isValidCell(key: string, cellValue: string) {
    this.errorImportMsg = null;
    const isCheckboxColumn = this.keysBoolean.includes(key);
    if (isCheckboxColumn) {
      const isValidCheckbox =
        isEmpty(cellValue) ||
        (typeof cellValue === "string" && cellValue.toLowerCase() === "x");
      if (!isValidCheckbox) this.errorImportMsg = "invalid_variable_checkbox";
      return isValidCheckbox;
    } else {
      if (key === "variableName") {
        if (isEmpty(cellValue)) this.errorImportMsg = "blank_variable_name";
        return !isEmpty(cellValue);
      }
      if (key === "memory") {
        if (isEmpty(cellValue))
          this.errorImportMsg = "blank_variable_memory_name";
        return !isEmpty(cellValue);
      }
      if (key === "type") {
        if (isEmpty(cellValue)) {
          this.errorImportMsg = "blank_variable_type_name";
          return false;
        }
        const isValidCheck = ["BOOL", "BYTE", "UBYTE", "WORD" , "FLOATING", "TIME"].includes(
          cellValue
        );
        if (!isValidCheck) this.errorImportMsg = "invalid_variable_type";
        return isValidCheck;
      }
    }
    return true;
  }

  onFileInputChange(filesTarget) {
    this.importVariableData = [];
    let reader = new FileReader();

    reader.onload = (e) => {
      const data = (e.target as any).result;
      let workbook = read(data, {
        type: "binary",
      });

      workbook.SheetNames.forEach((sheetName: string) => {
        const XL_row_object = utils.sheet_to_json(workbook.Sheets[sheetName], {
          defval: "",
          header: 1,
        });
        this.importVariableData.push(XL_row_object);
      });
    };

    reader.onerror = (ex) => {
      console.log(ex);
    };

    reader.onloadend = () => {
      this.doImport();
    };

    reader.readAsBinaryString(filesTarget.files[0]);
  }
}
